import { createSelector } from "@reduxjs/toolkit";
import { toMods } from "@src/store/slices/experienceBuilder/common/utils/toMods";
import { selectedComponents } from "@src/store/slices/experienceComponents";
import { selectedOnsiteEdits } from "@src/store/slices/onsiteEdits";
import { selectedInjections } from "@src/store/slices/onsiteInjections";

export const getInitialMods = createSelector(
  selectedOnsiteEdits,
  selectedInjections,
  selectedComponents,
  (onsiteEdits, onsiteInjections, components) =>
    toMods({ onsiteEdits, onsiteInjections, components })
);
